module.exports = __webpack_public_path__ + "static/media/MHRP09N0005.c5fb6ec8.svg";